export const GleecDomainDisclaimer = () => (
  <p className='mx-auto mt-3 max-w-2xl px-4 text-center font-sans text-xs leading-relaxed text-slate-600 dark:text-slate-400'>
    Formerly the Komodo Platform domain, now part of the Gleec ecosystem.
  </p>
);
